import {
  type PromotionsApi,
  PromotionsApiClient,
} from '@fourthwall/services/dist/PromotionsApiClient'
import { decodeHtmlEntities } from '@fourthwall/utils/dist/sanitize'
import { type UseInfiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query'

const PAGE_SIZE = 20

export const usePromotionsInfiniteQuery = (
  params?: PromotionsApi.GetPromotions.Params,
  options?: UseInfiniteQueryOptions<PromotionsApi.GetPromotions.Response>,
) => {
  const query = useInfiniteQuery<PromotionsApi.GetPromotions.Response>(
    ['promotionsInfinite', params],
    async ({ pageParam = 0 }) => {
      const { data } = await PromotionsApiClient.getPromotions({
        page: pageParam,
        size: PAGE_SIZE,
        ...params,
      })

      return data
    },
    {
      getNextPageParam: ({ page: { hasNextPage, pageNumber } }) => hasNextPage && pageNumber + 1,
      select: (data) => {
        data.pages[0].promotions = data.pages[0].promotions.map((promotion: any) => ({
          ...promotion,
          title: 'title' in promotion ? decodeHtmlEntities(promotion.title) : undefined,
        }))

        return data
      },
      keepPreviousData: true,
      ...options,
    },
  )

  return { query }
}
